import { Tabs as CKTabs, Box } from "@chakra-ui/react";
import { type ReactNode, useState } from "react";

import styles from "./Tabs.module.css";

export interface TabsProps {
  tabs: {
    label: string | ReactNode;
    disabled?: boolean;
    width?: string;
  }[];
  defaultIndex?: number;
  onChange?: (index: number) => void;
  width?: string;
}

export const Tabs = ({
  tabs,
  defaultIndex = 0,
  onChange,
  width = "100%",
}: TabsProps) => {
  const [activeIndex, setActiveIndex] = useState(defaultIndex);

  const handleTabChange = (index: number) => {
    setActiveIndex(index);
    if (onChange) {
      onChange(index);
    }
  };

  return (
    <Box className={styles.tabsWrapper} width={width}>
      <CKTabs.Root
        value={String(activeIndex)}
        onValueChange={(details) => handleTabChange(Number(details.value))}
        variant="plain"
        className={styles.tabs}
      >
        <CKTabs.List className={styles.tabList}>
          {tabs.map((tab, index) => (
            <CKTabs.Trigger
              key={index}
              value={String(index)}
              disabled={tab.disabled}
              className={styles.tab}
              width={tab.width}
            >
              {tab.label}
            </CKTabs.Trigger>
          ))}
        </CKTabs.List>
      </CKTabs.Root>
    </Box>
  );
};
